export default __webpack_public_path__ + "static/media/PurchaseLinkIndicatorPersonaliseActive.ba4bd72a.svg";